import React from "react";
import "./aboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-card">
        <div className="about-header">
          <span className="about-badge">Jyotirvani.com</span>
          <h1>About Us</h1>
          <h2>Founder – Astrologer Gopal Krishna</h2>
        </div>

        <div className="about-content">
          <p>
            Astrologer Gopal Krishna, the founder of <strong>Jyotirvani.com</strong>, is one of India's most respected and top-ranked astrologers, known for his deep knowledge and spiritually-rooted guidance. Born in Kanpur Dehat, Uttar Pradesh, he received his early education there and showed a keen interest in astrology and Vedic traditions from a young age.
          </p>

          <p>
            To pursue his passion further, he moved to the holy city of <strong>Vrindavan, Mathura</strong>, where he immersed himself in spiritual learning. He completed his higher education from the prestigious <strong>Rang Ji Mahavidyalaya</strong>, Parikrama Marg, Vrindavan, specializing in Sanskrit, Vedic astrology, and ancient scriptures.
          </p>

          <p>
            With over <strong>12 years of practical experience</strong>, Gopal Krishna Ji has mastered Vedic astrology, Vastu Shastra, Prashna Kundali, Face Reading, and Karmkand. His sharp predictions, insightful counseling, and simple yet effective remedies have positively transformed the lives of thousands across the country.
          </p>

          <p>
            In addition to his astrological work, he is also employed in the <strong>Government sector</strong>, where he continues to serve society with dedication and integrity. Balancing both worlds, he embodies discipline, devotion, and wisdom.
          </p>

          <p>
            Today, he stands among the top astrologers in India, with a reputation built on trust, accuracy, and deep spiritual connection. Through <strong>Jyotirvani.com</strong>, he aims to offer authentic, sacred, and science-backed astrological services to seekers worldwide.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;